"use strict";
const heroSection = document.querySelector('.rework-hero');
const loopTimeout = 7500;
function changeActiveSlide(direction, slides) {
    // Get current slide and it's index
    const currentActiveSlide = heroSection.querySelector('.hero-slide[data-active=true]');
    const currentActiveSlideIndex = Array.from(slides).indexOf(currentActiveSlide);
    // Create placeholder for next slide index
    let nextIndex = currentActiveSlideIndex;
    // Change the active slide
    if (direction === 'next') {
        // Increment index
        nextIndex++;
        // Reset to start if going to overflow
        if (nextIndex >= slides.length) {
            nextIndex = 0;
        }
    }
    else {
        // De-increment index
        nextIndex--;
        // Reset to end if going to overflow
        if (nextIndex < 0) {
            nextIndex = slides.length - 1;
        }
    }
    // Change datasets of slides
    slides[currentActiveSlideIndex].dataset.active = 'false';
    slides[nextIndex].dataset.active = 'true';
}
function timeoutLoop(slides) {
    // @ts-ignore
    window.timeoutLoops.forEach((loop, index) => {
        clearTimeout(loop); // @ts-ignore
        window.timeoutLoops.splice(index, 1);
    }); // @ts-ignore
    window.timeoutLoops = [];
    // Change active slide
    changeActiveSlide('next', slides);
    // Create recursive timout
    const timeoutId = window.setTimeout(() => {
        timeoutLoop(slides);
    }, loopTimeout);
    // @ts-ignore
    window.timeoutLoops.push(timeoutId);
}
function initHeroSlider() {
    // Get required DOM elements
    const controls = heroSection.querySelectorAll('.rework-hero__slide-control');
    const slides = heroSection.querySelectorAll('.hero-slide');
    // @ts-ignore Create placeholder for called timeouts
    window.timeoutLoops = [];
    // Add slider loop
    window.setTimeout(() => {
        timeoutLoop(slides);
    }, loopTimeout);
    // Add click events to buttons
    controls.forEach((control, index) => {
        control.addEventListener('click', (event) => {
            // @ts-ignore
            window.timeoutLoops.forEach((loop, index) => {
                clearTimeout(loop); // @ts-ignore
                window.timeoutLoops.splice(index, 1);
            }); // @ts-ignore
            // Change the active slide
            if (index === 0) {
                changeActiveSlide('prev', slides);
            }
            else {
                changeActiveSlide('next', slides);
            }
            // @ts-ignore Add slider loop
            window.timeoutLoops.push(window.setTimeout(() => {
                timeoutLoop(slides);
            }, loopTimeout));
        });
    });
}
if (heroSection) {
    initHeroSlider();
}
